/* =============================================
   LA PAISITA — THEME JS v4
   ── Envío: $15.000 COP por producto ──────────
   CONFIGURACIÓN REQUERIDA (una sola vez):
   1. En Shopify Admin → Productos → crear producto
      llamado "Envío" con precio $15.000 COP,
      sin inventario, sin envío físico.
   2. Copiar el Variant ID del producto "Envío"
      y pegarlo abajo en SHIPPING_VARIANT_ID.
============================================= */

// ▼▼▼ PEGA AQUÍ EL VARIANT ID DEL PRODUCTO "ENVÍO" ▼▼▼
const SHIPPING_VARIANT_ID = '50242550825153';
// ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲

const SHIPPING_PER_ITEM = 18000; // $18.000 COP por producto

document.addEventListener('DOMContentLoaded', function () {

  // ── Cart Toggle ──────────────────────────
  const cartToggle  = document.getElementById('cart-toggle');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose   = document.getElementById('cart-close');

  if (cartToggle && cartOverlay) {
    cartToggle.addEventListener('click', () => {
      renderCartDrawer();
      cartOverlay.classList.toggle('hidden');
    });
    cartClose?.addEventListener('click', () => cartOverlay.classList.add('hidden'));
    cartOverlay.addEventListener('click', (e) => {
      if (e.target === cartOverlay) cartOverlay.classList.add('hidden');
    });
  }

  // ── Cart Count ───────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── Helpers de formato ───────────────────
  function toCOP(cents) {
    return (cents / 100).toLocaleString('es-CO', {
      style: 'currency', currency: 'COP', minimumFractionDigits: 0
    });
  }
  function rawCOP(pesos) {
    return pesos.toLocaleString('es-CO', {
      style: 'currency', currency: 'COP', minimumFractionDigits: 0
    });
  }

  // ── Cart Drawer Content ───────────────────
  function renderCartDrawer() {
    const body = document.getElementById('cart-body');
    if (!body) return;

    body.innerHTML = '<p class="cart-empty" style="opacity:.5">Cargando...</p>';

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-empty">Tu carrito esta vacio</p>';
          return;
        }

        // Envío fijo: $18.000 por pedido (sin importar cantidad de productos)
        const shippingTotal = SHIPPING_PER_ITEM;
        const grandTotal    = (cart.total_price / 100) + shippingTotal;

        let html = '<div class="cart-items">';
        cart.items.forEach(item => {
          const price   = toCOP(item.final_price);
          const safeKey = String(item.key);

          html += `
            <div class="cart-line" style="display:flex;gap:12px;margin-bottom:16px;padding-bottom:16px;border-bottom:1px solid #eee;align-items:flex-start">
              <img src="${item.image}" alt="${item.title}"
                style="width:68px;height:68px;object-fit:cover;border-radius:8px;flex-shrink:0;border:1px solid #f0f0f0">
              <div style="flex:1;min-width:0">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px">
                  <p style="font-family:'Oswald',sans-serif;font-weight:600;font-size:.86rem;text-transform:uppercase;line-height:1.25;flex:1">${item.product_title}</p>
                  <button
                    class="cart-remove"
                    data-key="${safeKey}"
                    title="Eliminar"
                    style="cursor:pointer;color:#bbb;flex-shrink:0;padding:2px;background:none;border:none;transition:color .2s;font-size:1rem;line-height:1"
                  >&#10005;</button>
                </div>
                ${item.variant_title && item.variant_title !== 'Default Title'
                  ? `<p style="font-size:.74rem;color:#aaa;margin-top:2px">${item.variant_title}</p>`
                  : ''}
                <div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px">
                  <p style="font-family:'Oswald',sans-serif;color:#CC0000;font-weight:700;font-size:1rem">${price}</p>
                  <div style="display:flex;align-items:center;gap:0;border:1px solid #ddd;border-radius:6px;overflow:hidden">
                    <button
                      class="cart-qty-btn cart-qty-minus"
                      data-key="${safeKey}"
                      data-qty="${item.quantity - 1}"
                      style="cursor:pointer;width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:#fafafa;border:none;font-size:1rem;color:#333;transition:background .2s"
                    >&#8722;</button>
                    <span style="min-width:28px;text-align:center;font-size:.88rem;font-weight:700;font-family:'Oswald',sans-serif">${item.quantity}</span>
                    <button
                      class="cart-qty-btn cart-qty-plus"
                      data-key="${safeKey}"
                      data-qty="${item.quantity + 1}"
                      style="cursor:pointer;width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:#fafafa;border:none;font-size:1rem;color:#333;transition:background .2s"
                    >&#43;</button>
                  </div>
                </div>
              </div>
            </div>`;
        });

        // ── Resumen con envío ──
        html += `</div>
          <div style="border-top:2px solid #eee;padding-top:14px;margin-top:4px;display:flex;flex-direction:column;gap:6px">

            <div style="display:flex;justify-content:space-between;font-family:'Open Sans',sans-serif;font-size:.85rem;color:#555">
              <span>Subtotal</span>
              <span>${toCOP(cart.total_price)}</span>
            </div>

            <div style="display:flex;justify-content:space-between;align-items:flex-start;font-family:'Open Sans',sans-serif;font-size:.85rem;color:#555">
              <span>Envío<span style="font-size:.72rem;color:#999;margin-left:4px">(tarifa fija por pedido)</span></span>
              <span style="white-space:nowrap">${rawCOP(shippingTotal)}</span>
            </div>

            <div style="display:flex;justify-content:space-between;font-family:'Oswald',sans-serif;font-size:1.18rem;font-weight:700;padding-top:8px;border-top:1px solid #eee;margin-top:4px">
              <span>Total</span>
              <span style="color:#CC0000">${rawCOP(grandTotal)}</span>
            </div>

          </div>`;

        body.innerHTML = html;

        // ── Event delegation: +/- y eliminar ─────
        body.addEventListener('click', function handler(e) {
          const qtyBtn = e.target.closest('.cart-qty-btn');
          if (qtyBtn) {
            const key = qtyBtn.dataset.key;
            const qty = parseInt(qtyBtn.dataset.qty, 10);
            cartUpdateLine(key, qty < 0 ? 0 : qty);
            return;
          }
          const removeBtn = e.target.closest('.cart-remove');
          if (removeBtn) {
            const key = removeBtn.dataset.key;
            cartUpdateLine(key, 0);
            return;
          }
        }, { once: true });

      })
      .catch(() => {
        const body = document.getElementById('cart-body');
        if (body) body.innerHTML = '<p class="cart-empty">Error al cargar el carrito. Recarga la pagina.</p>';
      });
  }

  // ── Actualizar linea del carrito ──────────
  function cartUpdateLine(key, quantity) {
    const body = document.getElementById('cart-body');
    if (body) body.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(() => {
      updateCartCount();
      renderCartDrawer();
      if (body) body.style.opacity = '1';
    })
    .catch(() => {
      if (body) body.style.opacity = '1';
    });
  }

  // ── Botón "Pagar ahora" → agrega envío antes de checkout ──
  const checkoutBtn = document.getElementById('checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (!SHIPPING_VARIANT_ID) {
        window.location.href = '/checkout';
        return;
      }

      const originalText = checkoutBtn.textContent;
      checkoutBtn.textContent = 'Procesando...';
      checkoutBtn.disabled = true;

      // 1. Obtener carrito actual
      fetch('/cart.js')
        .then(r => r.json())
        .then(function(cart) {
          if (cart.item_count === 0) {
            window.location.href = '/checkout';
            return Promise.reject('empty');
          }

          // 2. Limpiar líneas de envío previas para no duplicar
          var shippingLines = cart.items.filter(function(i) {
            return String(i.variant_id) === String(SHIPPING_VARIANT_ID);
          });

          if (shippingLines.length === 0) return Promise.resolve();

          var clearOps = shippingLines.map(function(line) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
          return Promise.all(clearOps);
        })
        .then(function() {
          // 3. Agregar envío con FormData (más compatible con Shopify)
          var fd = new FormData();
          fd.append('id', SHIPPING_VARIANT_ID);
          fd.append('quantity', '1');
          fd.append('properties[_tipo]', 'envio');

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          });
        })
        .then(function(r) {
          if (r && !r.ok) {
            return r.json().then(function(err) {
              var msg = (err && (err.description || err.message)) ? (err.description || err.message) : JSON.stringify(err);
              console.error('Error envio:', err);
              alert('Error al agregar envío: ' + msg + ' | Variant ID: ' + SHIPPING_VARIANT_ID);
              checkoutBtn.textContent = originalText;
              checkoutBtn.disabled = false;
              return Promise.reject('shipping_error');
            });
          }
          window.location.href = '/checkout';
        })
        .catch(function(reason) {
          if (reason === 'empty' || reason === 'shipping_error') return;
          console.error('Checkout error:', reason);
          window.location.href = '/checkout';
        });
    });
  }

  // ── Add to Cart (AJAX) ───────────────────
  function handleCartFormSubmit(e) {
    const form = e.target.closest('.add-to-cart-form');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('button[type=submit]');
    if (!btn) return;
    const originalText = btn.innerHTML;
    btn.innerHTML = 'Agregando...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(r => {
      if (!r.ok) return r.json().then(err => { throw new Error(err.description || 'Error'); });
      return r.json();
    })
    .then(() => {
      btn.innerHTML = '✓ Agregado';
      updateCartCount();
      renderCartDrawer();
      if (cartOverlay) cartOverlay.classList.remove('hidden');
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2200);
    })
    .catch((err) => {
      btn.innerHTML = err.message || 'Error. Intenta de nuevo';
      btn.disabled = false;
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 3000);
    });
  }

  document.addEventListener('submit', handleCartFormSubmit);

  // ── Mobile Nav ───────────────────────────
  const hamburger = document.getElementById('hamburger');
  const mainNav   = document.getElementById('main-nav');
  const navClose  = document.getElementById('nav-close');

  if (hamburger && mainNav) {
    const openNav  = () => { mainNav.classList.add('is-open');    document.body.style.overflow = 'hidden'; };
    const closeNav = () => { mainNav.classList.remove('is-open'); document.body.style.overflow = '';       };

    hamburger.addEventListener('click', openNav);
    navClose?.addEventListener('click', closeNav);
    mainNav.querySelectorAll('.nav__link').forEach(link => {
      link.addEventListener('click', closeNav);
    });
  }

  // ── Countdown Timer ──────────────────────
  const timerEl = document.getElementById('countdown-timer');
  if (timerEl) {
    const endDate = timerEl.getAttribute('data-end');
    const end = endDate ? new Date(endDate + 'T00:00:00') : new Date('2026-07-19T00:00:00');
    const pad = n => String(n).padStart(2, '0');

    function tick() {
      const diff = end - new Date();
      if (diff <= 0) {
        ['cd-days','cd-hours','cd-mins','cd-secs'].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.textContent = '00';
        });
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000)  / 60000);
      const s = Math.floor((diff % 60000)    / 1000);
      const cd = document.getElementById('cd-days');
      const ch = document.getElementById('cd-hours');
      const cm = document.getElementById('cd-mins');
      const cs = document.getElementById('cd-secs');
      if (cd) cd.textContent = pad(d);
      if (ch) ch.textContent = pad(h);
      if (cm) cm.textContent = pad(m);
      if (cs) cs.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── Scroll Reveal ────────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.product-card, .trust-item, .faq-item, .kit-item').forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(28px)';
    el.style.transition = `opacity 0.5s ease ${i * 0.06}s, transform 0.5s ease ${i * 0.06}s`;
    observer.observe(el);
  });

  // ── Smooth scroll ────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const headerH = document.querySelector('.site-header')?.offsetHeight || 66;
        const top = target.getBoundingClientRect().top + window.scrollY - headerH;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});
